module.exports = __webpack_public_path__ + "img/logo.21f44e9d.png";